import { Car, Home, Building2, Heart } from "lucide-react";

export const insuranceTypes = [
  {
    value: "auto",
    label: "Auto Insurance",
    icon: Car,
    description: "Coverage for your vehicles"
  },
  {
    value: "home",
    label: "Home Insurance",
    icon: Home,
    description: "Protect your property"
  },
  {
    value: "business",
    label: "Business Insurance",
    icon: Building2,
    description: "Safeguard your company"
  },
  {
    value: "life",
    label: "Life Insurance",
    icon: Heart,
    description: "Secure your family's future"
  }
] as const;